module.exports = __webpack_public_path__ + "static/img/detail_allstate_02.7396efb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/allstate-field-goal-challenge/detail_allstate_02.jpg
// module id = 223
// module chunks = 2